module.exports = __webpack_public_path__ + "assets/img/returnBtn-b4bc60d1.png";